const stripSingleQuotes = (v) => {
    if (typeof v !== "string") return v;
    return v.replace(/['’‘]/g, "");
};

const sanitizeStrings = (obj) => {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
        if (k === "copypdf") {
            out[k] = v;
            continue;
        }
        out[k] = typeof v === "string" ? stripSingleQuotes(v) : v;
    }
    return out;
};


export  const buildCreateRequestPayload = (values, user,finalReqNumber,language,copyPdfBase64,campaign) => {
   const payload =  {
        request_number: finalReqNumber,
        applicant_id: user.token,
        info: values.historyMission ?? "",
        description: values.requestDescription ?? "",
        amount: Number(values.amount) || 0,
        currency_id: values.currency,

        copy: 1,
        fileupload: 0,

        reqdate: new Date().toISOString(),
        creationdate: new Date().toISOString(),
        org_learnforus: values.learnForUs,
        // org_mission: values.orgMission,
        // org_registsredasper: values.orgRegisteredAsPer,
        // org_dateestablished: values.orgDateEstablished,
        // org_fiscalsponsor: values.orgFiscalSponsor,
        //Campaignagreement: values.campaignAgreement ? 1 : 0,


        org_name_el: values.orgName,
        org_name_en: values.orgName_en,
        org_trn: values.tin,
        org_address: values.address1,
        org_street_number: values.address2,
        org_city: values.city,
        org_zip: values.zip,
        org_country_id: values.country,
        org_county: values.state,
        org_telno: values.phone,
        org_email: values.email,
        org_website: values.website,
        org_facebook: values.facebook,
        org_twitter: values.x,
        org_instagram: values.instagram,
        org_othersocialnetwork: values.otherSocial,
        org_act_onbehalf_of_org: values.authorized,
        org_info: values.historyMission,
        // org_subprogramarea: campaign == '30years'? 2 : 1,

        legalrep_title: values.repTitle,
        legalrep_firstname: values.repFirstName,
        legalrep_firstname_lat: values.repFirstName_en,
        legalrep_lastname: values.repLastName,
        legalrep_lastname_lat: values.repLastName_en,
        legalrep_hierarchy: values.repPositionTitle,
        legalrep_telno: values.repFixedPhone,
        legalrep_mobile: values.repMobilePhone,
        legalrep_email: values.repEmail,


        reqresp_title: values.contactTitle,
        reqresp_firstname: values.contactFirstName,
        reqresp_firstname_lat: values.contactFirstName_en,
        reqresp_lastname: values.contactLastName,
        reqresp_lastname_lat: values.contactLastName_en,
        reqresp_hierarchy: values.contactPositionTitle,
        reqresp_telno: values.contactFixedPhone,
        reqresp_mobile: values.contactMobilePhone,
        reqresp_email: values.contactEmail,


        copypdf: copyPdfBase64 ?? '',
        portal_version: language,
    };
    const hits = Object.entries(payload)
        .filter(([k, v]) => k !== "copypdf" && typeof v === "string" && /['’‘]/.test(v))
        .map(([k]) => k);

    if (hits.length) console.warn("Removed single quotes from:", hits);
    return sanitizeStrings(payload);
};
